import { FormControlLabel, Stack, Switch, Typography } from "@mui/material";
import { handleBasicsChange } from "../../../Redux/reducers/questionSlice";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";

type Props = {
  question: any;
};
export const AddressTab = ({ question }: Props) => {
  const dispatch = useAppDispatch();

  const isAddressError = useAppSelector(
    ({ question }) => question.isAddressError
  );
  const isPreview = useAppSelector(({ question }) => !question.editable);

  const onChange = (key: string, value: string | boolean) => {
    if (!isPreview)
      dispatch(
        handleBasicsChange({
          key,
          value,
          isProp: true,
        })
      );
  };

  return (
    <Stack gap={2} py={1}>
      {isAddressError && (
        <Typography variant="caption" fontWeight="medium" color={"red"}>
          {isAddressError}
        </Typography>
      )}
      <FormControlLabel
        disabled={isPreview}
        control={<Switch checked={question.properties?.zipcode || false} />}
        label={
          <Typography variant="body1" fontWeight={"regular"}>
            Zipcode
          </Typography>
        }
      />
      <FormControlLabel
        disabled={isPreview}
        control={
          <Switch
            checked={question.properties?.city || false}
            onChange={(e) => onChange("city", e.target.checked)}
          />
        }
        label={
          <Typography variant="body1" fontWeight={"regular"}>
            City
          </Typography>
        }
      />
      <FormControlLabel
        disabled={isPreview}
        control={
          <Switch
            checked={question.properties?.state || false}
            onChange={(e) => onChange("state", e.target.checked)}
          />
        }
        label={
          <Typography variant="body1" fontWeight={"regular"}>
            State
          </Typography>
        }
      />
      <FormControlLabel
        disabled={isPreview}
        control={
          <Switch
            checked={question.properties?.country || false}
            onChange={(e) => onChange("country", e.target.checked)}
          />
        }
        label={
          <Typography variant="body1" fontWeight={"regular"}>
            Country
          </Typography>
        }
      />
    </Stack>
  );
};
